import type { AnyObject, QueryStringTransformer } from "../interfaces";

export function buildQueryString(obj: AnyObject) {
  const strBuilder: string[] = [];

  if(typeof obj !== "object" || !obj) {
    return obj;
  }

  if(typeof obj === "string" || typeof obj === "number") {
    return obj;
  }

  for(const [prop, value] of Object.entries(obj)) {
    if(Object.prototype.hasOwnProperty.call(obj, prop)) {
      strBuilder.push(encodeURIComponent(prop) + "=" + encodeURIComponent(value));
    }
  }

  return strBuilder.join("&");
}

export function containsQueryString(path) {
  return /[?&]/.test(path);
}

export function getLeadingQueryStringChar(path) {
  return containsQueryString(path) ? "&" : "?";
}

interface GetQueryStringAsObjectOptions { 
  query?: string;
  asObject?: boolean; 
  transformers?: Record<string, QueryStringTransformer>
  /*transformers?: {
    [key: string]: QueryStringTransformer;
  };*/
}

/**
 * import { getQueryStringAsObject } from "helpers/url"; 
 * import { parseAsBoolean, parseAsNumber, parseAsString } from "hooks/useQuery";
 * const { page, limit, isLastPage } = qetQueryStringAsObject({ 
 *   transformers: {
 *     page: parseAsNumber, 
 *     limit: parseAsNumber, 
 *     isLastPage: parseAsBoolean
 *     // ... every other is parsed as string (by default)
 *   }
 * }) 
 */
export function getQueryStringAsObject(options?: GetQueryStringAsObjectOptions) {
  options = options ?? { query: "", asObject: true, transformers: {} };

  const queryString = options.query;
  const params = new URLSearchParams(queryString ?? window.location.search);

  if(options.asObject) {
    const object = paramsToObject(params);
    const transformers = options.transformers ?? {};

    return Object.keys(transformers).reduce((acc, key) => {
      return {
        ...acc,
        [key]: transformers[key](acc[key]),
      }
    }, object);
  } else {
    return params; // Get query string values using params.get(key);
  }
}

export function updateBrowserUrlOnNavigate(state: AnyObject) {
  if(typeof window.history.pushState === "function") {
    const newUrl = new URL(window.location.href);
    
    for(const [prop, value] of Object.entries(state)) {
      if(Object.prototype.hasOwnProperty.call(state, prop)) {
        newUrl.searchParams.set(prop, value as string);
      }
    }

    window.history.pushState(state, "", newUrl.toString());
  }
}

function paramsToObject(entries) {
  return Object.fromEntries(entries);
}
